









































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SearchInput from '@/components/SearchInput/index.vue'
import KF from '@/components/KF/index.vue'
import City from '@/components/City/index.vue'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { getLoginUrl } from '@/api/user'

import { BaseStore, LettersType } from '@/store/modules/Base'
import { CityStore } from '@/store/modules/NavCity'
import { topColumn } from '@/api/home'

interface navBarListType {
  first: number
  id: number
  name: string
  status: number
  url: string
  icon: string
}

@Component({
  name: 'Nav',
  components: {
    SearchInput,
    City,
    KF
  }
})
export default class Nav extends Vue {
  private logo1 = require('../../assets/index-logo.png')

  private logo2 = require('../../assets/index-logo2.png')

  // 自定义Nav导航
  private navBarList: Array<navBarListType> = []

  // 点击索引
  private active: number | string = 0

  // 是否变色 0 默认 1 变白色
  private navTypeState = 0

  private lettersStatus = false // 是否获取过站内信

  private activeCityInfo: any = {} // 选中的城市信息

  // 跳转后台管理界面 需要拼接参数
  private userLoginPC = {
    url: '',
    user: ''
  }

  private cityShow = true

  private routePath = ''

  get navType () {
    if (BaseStore.scrollTop === 0) {
      return 1
    }
    return this.navTypeState
  }

  set navType (newData: number) {
    this.navTypeState = newData
  }

  get cityName (): string {
    return this.activeCityInfo.areaName || this.userInfo.areaName
  }

  // 商户自己的信息
  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  get letters (): LettersType {
    return BaseStore.letters
  }

  // 当路由跳转或者初始进入的时候设置点击状态
  @Watch('$route')
  setRouteActive (newValue: any): void {
    this.routePath = newValue.path
    let actived: number | string = sessionStorage.getItem('navActived') || ''
    for (let i = 0; i < this.navBarList.length; i++) {
      const item = this.navBarList[i]
      // 路由带?id=xxx包含时(搜索列表页) || 子级路由高亮
      if (item.url.includes(newValue.path) || newValue.path.includes(item.url)) {
        // if (newValue.query && newValue.query.type) {
        //   actived = 2
        //   break
        // }
        actived = i
        break
      }
    }
    this.active = actived
    sessionStorage.setItem('navActived', actived.toString())
    if (!this.lettersStatus && newValue.url !== '/login' && newValue.url !== '/') {
      this.handleScroll()
      BaseStore.API_COUNT_LETTERS()
      this.lettersStatus = true
    }

    // 只有再首页显示城市
    if (newValue.url === '/home') {
      this.cityShow = true
    } else {
      this.cityShow = false
    }
  }

  // 点击导航菜单
  clickNavBar (item: navBarListType, index): void {
    this.active = index
    if (!/^http/.test(item.url)) {
      this.$router.push(item.url)
    } else {
      window.open(item.url)
    }
  }

  clickDropdown (item: string): void {
    console.log(item)
    if (item === '/') {
      // debugger
      BaseStore.REMOVE_TOKEN()
      BaseStore.SET_POP_UP(true)
      UserStore.REMOVE_USER_INFO()
      sessionStorage.removeItem('navActived')
    }
    if (!/^http/.test(item)) {
      this.$router.push(item)
    } else {
      window.open(item)
    }
  }

  // 监听 浏览器滚动条
  handleScroll (): void {
    window.addEventListener('scroll', () => {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= BaseStore.scrollTop) {
        this.navType = 1
      } else {
        this.navType = 0
      }
    })
  }

  // 获取自定义Nav导航标题
  getTopColumn (): void {
    topColumn().then((res) => {
      if (res.success) {
        this.navBarList = res.data.results
      }
    })
  }

  getLoginUrl () {
    getLoginUrl()
      .then((res) => {
        if (res.success) {
          this.userLoginPC = res.data
        }
      })
  }

  // 切换城市
  changeCity (item) {
    this.activeCityInfo = item
    CityStore.SET_CITY_INFO(item)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.popover.showPopper = false
  }

  mounted (): void {
    this.getTopColumn()
    this.setRouteActive({
      path: location.hash.replace(/#/g, '').split('?')[0]
    })
    this.getLoginUrl()
  }
}
